var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgRoomService = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 12 12",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M1 9.5v-1h10v1H1ZM1.5 8v-.5c0-1.067.327-2.008.981-2.825A4.266 4.266 0 0 1 5 3.125V3c0-.275.098-.51.294-.706A.963.963 0 0 1 6 2c.275 0 .51.098.706.294A.963.963 0 0 1 7 3v.125a4.244 4.244 0 0 1 2.525 1.55c.65.817.975 1.758.975 2.825V8h-9Zm1.025-1h6.95a3.332 3.332 0 0 0-1.162-2.15A3.434 3.434 0 0 0 6 4a3.41 3.41 0 0 0-2.306.85A3.396 3.396 0 0 0 2.525 7Z"
})));
SvgRoomService.viewBox = '0 0 12 12';
const ForwardRef = /*#__PURE__*/forwardRef(SvgRoomService);
export default ForwardRef;